import { render, staticRenderFns } from "./reserve-record-detail-dialog.vue?vue&type=template&id=25b8240c&scoped=true"
import script from "./reserve-record-detail-dialog.vue?vue&type=script&lang=js"
export * from "./reserve-record-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./reserve-record-detail-dialog.vue?vue&type=style&index=0&id=25b8240c&prod&scoped=true&lang=css"
import style1 from "./reserve-record-detail-dialog.vue?vue&type=style&index=1&id=25b8240c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b8240c",
  null
  
)

export default component.exports